import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><path id=\"a\" d=\"M13.75 9.167a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666zm0-6.417a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667zm0 12.833a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667zm-5.5-6.416a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666zm0-6.417a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667zm0 12.833a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667z\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"></use></mask><use xlink:href=\"#a\" fill=\"currentColor\" fill-rule=\"nonzero\"></use><g fill=\"currentColor\" mask=\"url(#b)\"><path d=\"M0 0h22v22H0z\"></path></g></g>", 2)
  ]))]))
}
export default { render: render }